import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./templates.css";
import { config } from "../config";
import { renderAsync } from "docx-preview";
import FullScreenLoader from "../components/FullScreenLoader";
import LeftPanel from "../components/leftPanel";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet-async";
import GoogleButton from "../components/GoogleAuth"; 
export default function TemplatePreview() {
  const { templateName } = useParams();
  const navigate = useNavigate();
  const realTemplateName = `${templateName}.docx`;
  const [imageURLs, setImageURLs] = useState([]);
  const containerRef = useRef(null);
  const apiKey = process.env.REACT_APP_TEMPLATES_KEYS;
  const [fileBlob, setFileBlob] = useState(null);
  const [error, setError] = useState("");
  const [loadingDownload, setLoadingDownload] = useState(false);
  const googleAuthRef = useRef(null);
  function formatTitleFromSlug(slug) {
    if (!slug) return "";
    return slug
      .split("-")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const formattedTitles = formatTitleFromSlug(templateName);
const pageTitle = `${formattedTitles} Templates | Ai Legal Document Generator`;
const canonicalUrl = `https://legaldocumentgenerator.com/templates/${templateName}`;
  useEffect(() => {
    return () => {
      imageURLs.forEach(URL.revokeObjectURL);
    };
  }, [imageURLs]);

  useEffect(() => {
    if (!templateName) {
      setError("Template missing in URL.");
      return;
    }

     

    const url = `${config.baseURL.replace(/\/+$/, "")}/get_templates.php` +
                `?name=${encodeURIComponent(templateName)}` +
                `&action=preview`;
  
    fetch(url, {
      headers: { Authorization: `Bearer ${apiKey}` },
      credentials: "include",
    })
      .then(res => {
        if (!res.ok) throw new Error(`Preview HTTP ${res.status}`);
        return res.arrayBuffer();
      })
      .then(buffer => {
        const raw = new Uint8Array(buffer);
        const sig = new Uint8Array([0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A]);
        const positions = [];
  
        // 1) Find every occurrence of the PNG signature
        for (let i = 0; i < raw.length - sig.length; i++) {
          let match = true;
          for (let j = 0; j < sig.length; j++) {
            if (raw[i + j] !== sig[j]) {
              match = false;
              break;
            }
          }
          if (match) positions.push(i);
        }
  
        if (positions.length === 0) {
          throw new Error("No PNG signatures found – malformed stream.");
        }
  
        // 2) Slice out each chunk between signatures
        const urls = [];
        for (let idx = 0; idx < positions.length; idx++) {
          const start = positions[idx];
          const end   = idx + 1 < positions.length
                      ? positions[idx + 1]
                      : buffer.byteLength;
          const slice = buffer.slice(start, end);
          const blob  = new Blob([slice], { type: "image/png" });
          urls.push(URL.createObjectURL(blob));
        }
  
        setImageURLs(urls);
      })
      .catch(err => {
       
        setError(err.message);
      });
  }, [templateName, config.baseURL]);
  
  

  const handleDownload = async () => {
    setLoadingDownload(true);
    try {
      const url =
        `${config.baseURL.replace(/\/+$/, "")}/get_templates.php?` +
        `name=${encodeURIComponent(realTemplateName)}&action=download`;
  
      const res = await fetch(url, { credentials: "include" });
  
      // Handle HTTP error responses
      if (!res.ok) {
        const data = await res.json();
        console.log("API Response:", data);
  
        if (res.status === 401) {
          googleAuthRef.current?.login();
        } else if (res.status === 403) {
          toast.info("Please upgrade to Pro to download this template.");
          setTimeout(() => navigate("/premium"), 3500);
        } else if (res.status === 404) {
          toast.error("File not found. Please try again later.");
        } else {
          toast.error("Unexpected error. Please try again later.");
        }
        return;
      }
  
      const data = await res.json();
      if (data.download_url) {
        window.open(data.download_url, "_blank");
      } else {
        toast.error("Unexpected error. Please try again later.");
      }
    } catch (err) {
      console.error("Download error:", err);
      toast.error("Unexpected error. Please try again later.");
    } finally {
      setLoadingDownload(false);
    }
  };

  const formattedTitle = templateName
    ? templateName.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "";

 /*  if (error) return <p className="error-text">Error: {error}</p>;
  if (!fileBlob) return <FullScreenLoader />;  */

  const handleLoginSuccess = (userData) => {
      toast.success("Login Complete");
    };
  
    const handleLoginFailure = () => {};
   if (error) {
    return <p className="error-text">Error: {error}</p>;
  }
  
  // show loader while images are still coming back
  if (imageURLs.length === 0) {
    return <FullScreenLoader />;
  } 
  return (
    <>
     <Helmet key="landing">
          <title>{pageTitle}</title>
        <meta
          name="description"
          content={`Download and preview ${formattedTitle} using our AI-powered legal document generator. Customizable, fast, and compliant.`}
        />
         <meta
    name="keywords"
    content="download legal templates, legal document templates docx, employment contract download, NDA template docx, lease agreement word format, will and testament docx, divorce agreement template, business contracts download, freelance agreement word, marriage contract docx, privacy policy word format, rental agreement download, statement of work docx, partnership agreement template, website terms and conditions download, editable legal forms"
  />
        <link rel="canonical" href={canonicalUrl} />
          </Helmet>
      <div className="create_background">
        <LeftPanel />
        <div className="create_main templates_preview">
          <div className="templates_header">          <div className="templates_title">
            <img
              src={config.Backbutton}
              alt="back"
              onClick={() => navigate(-1)}
            />
            {formattedTitle}
            
          </div>
         
              <button
                className="download-button-header"
                onClick={handleDownload}
                disabled={loadingDownload}
              >
                {loadingDownload ? "Preparing..." : "Download Template"}
              </button>
           
          </div>


          <div className="template-preview-page">
       
                      <div className="images-wrapper">
              {imageURLs.map((src, idx) => (
                <img
                  key={idx}
                  src={src}
                  alt={`Page ${idx + 1}`}
                  draggable={false}
                  onContextMenu={e => e.preventDefault()}
                />
              ))}
            </div>
            <div>
              <button
                className="download-button"
                onClick={handleDownload}
                disabled={loadingDownload}
              >
                {loadingDownload ? "Preparing..." : "Download Template"}
              </button>
            </div> 

            <GoogleButton
                              id="loginHidden"
                              ref={googleAuthRef}
                              onLoginSuccess={handleLoginSuccess}
                              onLoginFailure={handleLoginFailure}
                            />
                          

            <ToastContainer position="top-center" />
          </div>
        </div>
      </div>
    </>
  );
}
